import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import KotiLayout from "./layout/KotiLayout";
import { useEffect } from "react";
import { scroll6IfTop } from "src/components/js/statics1";

export default function KotiCore() {
  // set page title
  useEffect(() => {
    document.title = "betoni-online koti";
    localStorage.setItem("lastKnownUrl", window.location.pathname);
    scroll6IfTop();
  }, []);

  return (
    <div style={{ minHeight: "calc(100vh - 150px)" }}>
      <AuthAccess page="koti" showError>
        <KotiLayout />
      </AuthAccess>
    </div>
  );
}
